import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import relativeLink from 'utils/routes/relativeLink';

export type AppLinkProps = LinkProps & { external?: boolean; to: string };

export const AppLink: React.FC<AppLinkProps> = ({ external = false, children, to, ...props }) => {
  return external && typeof to === 'string' ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <a href={to} {...(props as unknown)}>
      {children}
    </a>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link to={relativeLink(to)} {...props}>
      {children}
    </Link>
  );
};

export default AppLink;
